import { SystemField } from "./system-field";

export class LocationArea extends SystemField{ 
    name?:string;
    post_code?:string;
    parent_id?:string;
    area_type?:string;
    lat?:number;
    log?:number;
}
